import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import * as React from 'react';
import { mergeStyles } from '@cian/utils';
import { trackFloorFilterChange } from '../../utils/tracking';
import { iconArrowDown } from './icon_arrow_down';
import * as styles from './index.css';
import { createElement as _createElement } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var FLOORS_LIMIT = 10;
export var FloorFilter = /*#__PURE__*/function (_React$Component) {
  _inherits(FloorFilter, _React$Component);
  var _super = _createSuper(FloorFilter);
  function FloorFilter(props) {
    var _this;
    _classCallCheck(this, FloorFilter);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "shouldRenderScrollTopButton", function (selectedFloor) {
      var floorsWithFlats = _this.props.floorsWithFlats;
      return floorsWithFlats.length > 0 && floorsWithFlats[floorsWithFlats.length - 1] !== selectedFloor;
    });
    _defineProperty(_assertThisInitialized(_this), "shouldRenderScrollDownButton", function (selectedFloor) {
      var floorsWithFlats = _this.props.floorsWithFlats;
      return floorsWithFlats.length > 0 && floorsWithFlats[0] !== selectedFloor;
    });
    _defineProperty(_assertThisInitialized(_this), "getFloorsLimit", function (selectedFloor) {
      if (_this.shouldRenderScrollDownButton(selectedFloor) && _this.shouldRenderScrollTopButton(selectedFloor)) {
        return FLOORS_LIMIT - 1;
      }
      return FLOORS_LIMIT;
    });
    _defineProperty(_assertThisInitialized(_this), "handleScrollFloor", function (increment) {
      return function () {
        var _this$props = _this.props,
          selectedFloor = _this$props.selectedFloor,
          floorsWithFlats = _this$props.floorsWithFlats;
        var currentFloorIndex = floorsWithFlats.findIndex(function (floor) {
          return selectedFloor === floor;
        });
        var nextFloor = floorsWithFlats[currentFloorIndex + increment];
        if (!nextFloor) {
          return;
        }
        _this.setState({
          visibleFloors: _this.getNextVisibleFloors(nextFloor, increment)
        });
        _this.setFloor(nextFloor);
      };
    });
    _defineProperty(_assertThisInitialized(_this), "handleSelectFloor", function (nextFloor) {
      var selectedFloor = _this.props.selectedFloor;
      if (selectedFloor) {
        _this.setState({
          visibleFloors: _this.getNextVisibleFloors(nextFloor, nextFloor > selectedFloor ? 1 : -1)
        });
      }
      _this.setFloor(nextFloor);
    });
    _defineProperty(_assertThisInitialized(_this), "getNextVisibleFloors", function (nextFloor, increment) {
      var _this$props2 = _this.props,
        floors = _this$props2.floors,
        floorsWithFlats = _this$props2.floorsWithFlats;
      // если increment === 0, то это этап инициализации в конструкторе и еще нет this.state
      var visibleFloors = increment === 0 ? [] : _this.state.visibleFloors;
      var floorsLimit = _this.getFloorsLimit(nextFloor);
      var nextFloorIndex = floors.findIndex(function (floor) {
        return nextFloor === floor;
      });
      var isLastFloorWithFlats = floorsWithFlats[floorsWithFlats.length - 1] === nextFloor;
      var isFirstFloorWithFlats = floorsWithFlats[0] === nextFloor;
      var minStart = Math.max(floors.length - floorsLimit, 0);
      if (isLastFloorWithFlats && nextFloorIndex < floorsLimit) {
        return floors.slice(0, floorsLimit);
      } else if (isFirstFloorWithFlats && nextFloorIndex > minStart) {
        return floors.slice(minStart);
      } else if (visibleFloors.includes(nextFloor) && floorsLimit === visibleFloors.length) {
        return visibleFloors;
      }
      var sliceParams = [0, 0];
      if (increment >= 0) {
        sliceParams = nextFloorIndex + floorsLimit >= floors.length ? [Math.max(minStart - 1, 0), floors.length - 1] : [nextFloorIndex, nextFloorIndex + floorsLimit];
      } else {
        sliceParams = nextFloorIndex - floorsLimit < 0 ? [1, floorsLimit + 1] : [nextFloorIndex - floorsLimit + 1, nextFloorIndex + 1];
      }
      return floors.slice(sliceParams[0], sliceParams[1]);
    });
    _defineProperty(_assertThisInitialized(_this), "renderFloors", function () {
      var _this$props3 = _this.props,
        selectedFloor = _this$props3.selectedFloor,
        floorsWithFlats = _this$props3.floorsWithFlats;
      return _this.state.visibleFloors.map(function (floor) {
        return /*#__PURE__*/_createElement("div", _objectSpread(_objectSpread({}, mergeStyles(styles['button'], !floorsWithFlats.includes(floor) && styles['disabled'], selectedFloor === floor && styles['selected'])), {}, {
          key: floor,
          onClick: function onClick() {
            return _this.handleSelectFloor(floor);
          }
        }), floor);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "setFloor", function (floor) {
      trackFloorFilterChange(_this.props.isOfferCard);
      _this.props.setFloor(floor);
    });
    var _selectedFloor = props.selectedFloor;
    _this.state = {
      visibleFloors: _selectedFloor ? _this.getNextVisibleFloors(_selectedFloor, 0) : []
    };
    return _this;
  }
  _createClass(FloorFilter, [{
    key: "render",
    value: function render() {
      var selectedFloor = this.props.selectedFloor;
      return /*#__PURE__*/_jsxs("div", {
        className: styles['container'],
        children: [/*#__PURE__*/_jsx("div", {
          className: styles['title'],
          children: "\u042D\u0442\u0430\u0436"
        }), /*#__PURE__*/_jsx("div", {
          className: styles['floors-container'],
          children: /*#__PURE__*/_jsxs("div", {
            className: styles['floors'],
            children: [this.shouldRenderScrollTopButton(selectedFloor) && /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, mergeStyles(styles['button'], styles['button-scroll-up'])), {}, {
              onClick: this.handleScrollFloor(1),
              children: iconArrowDown
            })), this.renderFloors(), this.shouldRenderScrollDownButton(selectedFloor) && /*#__PURE__*/_jsx("div", {
              className: styles['button'],
              onClick: this.handleScrollFloor(-1),
              children: iconArrowDown
            })]
          })
        })]
      });
    }
  }]);
  return FloorFilter;
}(React.Component);